export const INSTRUCTOR_UPDATE_SELECTED_LAB = "INSTRUCTOR_UPDATE_SELECTED_LAB";
export const INSTRUCTOR_UPDATE_SELECTED_PROGRAM = "INSTRUCTOR_UPDATE_SELECTED_PROGRAM";
export const INSTRUCTOR_UPDATE_SELECTED_SUBMISSION = "INSTRUCTOR_UPDATE_SELECTED_SUBMISSION";
export const INSTRUCTOR_UPDATE_SELECTED_COURSE = "INSTRUCTOR_UPDATE_SELECTED_COURSE";